<template>
  <div class="pb-3">
    <p v-if="isLoading" class="ps-3">
      Loading ...
    </p>
    <p v-else-if="tags.length == 0" class="ps-3">
      Nessun tag creato
    </p>
    <ul v-if="!isLoading" class="tag-list">
      <Tag
        v-for="tag of tags"
        :tag="tag"
        :account-id="accountId"
        @edit="({tag}) => editTag(tag)"
      />
    </ul>
    <button
      v-if="userCan(CUP.MANAGE_TAGS)"
      type="button"
      class="btn btn-secondary btn-sm d-block mt-2 mx-auto"
      @click="initModal()"
    >
      <i class="fa fa-plus me-1"></i>
      Nuovo tag
    </button>
  </div>
</template>

<script setup>
import bus from '@/bus.js';
import * as tagService from '@/services/tag.service.js';
import { CORE_USER_PERMISSIONS as CUP } from '@/enums/CoreUserPermissions';
import { ref, onBeforeUnmount, inject, Teleport } from 'vue';

import Tag from './Tag.vue';
import AddTagModal from '@/components/Modals/AddTagModal.vue';

const props = defineProps(['accountId']);
const showModal = inject('showModal');
const userCan = inject('userCan');

let isLoading = ref(true);
let tags = ref([]);

let isAdding = ref(false);
let newTagName = ref("");


async function loadTags() {
  isLoading.value = true;
  let tagsRes = await tagService.getAllAsTrees(props.accountId);
  tags.value = tagsRes;
  isLoading.value = false;
}

async function newTag() {
  if (newTagName == "") return;

  let tag = await tagService.create(
    props.accountId,
    newTagName.value,
    null
  );

  isAdding.value = false;
  isLoading.value = true;
  await loadTags();
}

async function editTag(tag) {
  showModal('edit-tag-modal', props.accountId, tag);
}

async function tagAdded({account}) {
  if (props.accountId == account) {
    await loadTags();
  }
}

async function tagRemoved({account}) {
  if (props.accountId == account) {
    await loadTags();
  }
}

function initModal() {
  showModal('create-tag-modal', props.accountId, tags.value);
}

// Initialize component
loadTags();

// Initialize callbacks
bus.$on('tagAdded', tagAdded);
bus.$on('tagRemoved', tagRemoved);

onBeforeUnmount(() => {
  bus.$off('tagAdded', tagAdded);
  bus.$off('tagRemoved', tagRemoved);
});

</script>


<style scoped>
.container {
  padding-inline: 1rem;
}

.tag-list {
  margin: 0px;
  padding: 0px;
}

.new-tag-name {
  width: 100%;
  background-color: transparent;
  border: solid 0px;
  border-bottom: solid 1px #fff;
  color: #fff;
}

.icon-action {
  cursor: pointer;
  filter: brightness(0.8);
  transition: filter .3s;
}

.icon-action:hover {
  filter: brightness(1);
}

.no-margin.row {
  margin: 0px;
}
</style>
